import React, { useCallback, useEffect, useState } from "react";
import checkImg from "../../../assets/images/dw20/check.png";
import DidYouKnow from "../components/DidYouKnow";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
const DW20Result = ({
  isCzarPlayer,
  isWinnerPlayer,
  gameOutput,
  onNextRound,
  joke,
  screens,
  buzzer_sound,
  default_audio_effect
}) => {
  const [counter, setCounter] = useState(10);

  const lose_banner = _.get(
    screens,
    "5_result .other  .lose_banner  ",
    "You LOSE!"
  ).split(" ");
  const lose_text = _.get(
    screens,
    "5_result .other  .lose_text  ",
    "Such a disappointment..."
  );
  const win_banner = _.get(
    screens,
    "5_result .other  .win_banner ",
    "You WON this round!"
  ).split(" ");
  useEffect(() => {
    let timer;
    timer =
      counter > 0 && setInterval(() => setCounter((prev) => prev - 1), 1000);
    counter === 0 && onNextRound();
    return () => clearInterval(timer);
  }, [counter]);

  const handleNextRound = useCallback(
    _.debounce(() => onNextRound(), 500, {
      leading: true,
      trailing: false
    }),
    []
  );

  useEffect(() => {
    if (isWinnerPlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isWinnerPlayer, default_audio_effect]);

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="dw-result"
    >
      {isCzarPlayer ? (
        <> </>
      ) : (
        <>
          {isWinnerPlayer ? (
            <>
              <div className="d-flex justify-content-between flex-column h-100">
                <div>
                  <motion.h2 variants={fadeVariants} className="title">
                    {win_banner[0]} <span>{win_banner[1]}</span> {win_banner[2]}
                    <br />
                    {win_banner[3]}
                  </motion.h2>
                  <motion.img
                    variants={staticBounceVariants}
                    src={gameOutput?.win_url}
                    className="img-fluid img result-gif"
                    alt=""
                  />
                </div>
                <div className="check-icon">
                  <motion.img
                    variants={staticBounceVariants}
                    src={checkImg}
                    className="img-fluid checkImg"
                    alt=""
                    onClick={handleNextRound}
                  />
                  <p className="timer">{`(${counter})`}</p>
                  <motion.p variants={fadeVariants}>Ok</motion.p>
                </div>
              </div>
            </>
          ) : (
            <div>
              <motion.h2
                variants={staticBounceVariants}
                className="loose-title"
              >
                {lose_banner[0]} <span> {lose_banner[1]}</span>
              </motion.h2>
              <motion.p variants={fadeVariants} className="desc">
                {lose_text}
              </motion.p>
              <motion.img
                variants={staticBounceVariants}
                src={gameOutput?.lose_url}
                className="img-fluid img result-gif"
                alt=""
              />
            </div>
          )}
          {!isWinnerPlayer && <DidYouKnow joke={joke} />}
        </>
      )}
    </motion.div>
  );
};

export default DW20Result;
